import { toast } from "react-toastify";

import * as runReducer from "containers/Run/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as blueprintReducer from "containers/Blueprint/reducer";
import * as deploymentsReducer from "containers/Deployments/reducer";

const UPDATE_FIELD = "group/UPDATE_FIELD";

const initialState = {};

function groupReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    default:
      return state;
  }
}

/* Selectors */
export function getBase(state) {
  return state.group;
}

export function getGroup(state, id) {
  const run = runReducer.getTransformedJob(state, id);

  return {
    run: run,
    dataset: run && run.dataset ? run.dataset : undefined,
    setup: run && run.setup ? run.setup : undefined,
    blueprint:
      run && run.setup && run.setup.blueprintId !== undefined
        ? blueprintReducer.getBlueprint(state, run.setup.blueprintId)
        : undefined,
    deployments: deploymentsReducer.getDeploymentsFromJobId(state, id)
  };
}

export function getGroups(state) {
  return {};
}

export default groupReducer;
